import { Catalog } from '../../../catalog.types';
import { CatalogSidePanelContent } from '../hooks/catalogSidePanel.types';
import CatalogDetailsPanel from './CatalogDetailsPanel/CatalogDetailsPanel';
import LiveShopPanel from './LiveShopPanel/LiveShopPanel';

interface CatalogDetailsSlotContentProps {
  activeContent: CatalogSidePanelContent | null;
  videoId: string | null;
  embedDomain: string;
  catalog?: Catalog;
  isReadOnly: boolean;
}

const CatalogDetailsSlotContent = ({
  activeContent,
  videoId,
  embedDomain,
  catalog,
  isReadOnly,
}: CatalogDetailsSlotContentProps) => {
  if (activeContent === 'liveShop' && videoId) {
    return <LiveShopPanel isOpen videoId={videoId} embedDomain={embedDomain} />;
  }

  if (activeContent === 'details' && catalog) {
    return <CatalogDetailsPanel catalog={catalog} isReadOnly={isReadOnly} />;
  }

  return null;
};

export default CatalogDetailsSlotContent;
